import { useNavigate } from 'react-router-dom';
import Box from 'components/UI/Box/Box';
import Button from 'components/UI/Button';
import { ROUTE_PATH } from 'routes';
import useLiterals from 'utils/hooks/useLiterals';

const ReferralProgramCard = () => {
  const literals = useLiterals('referrals');
  const navigate = useNavigate();

  return (
    <Box className='referral-home-card mb-3' padding='none'>
      <p className='referral-home-card__eyebrow'>{literals.cardTitle}</p>
      <h4 className='referral-home-card__headline'>{literals.cardHeadline}</h4>
      <p className='referral-home-card__copy'>{literals.cardDescription}</p>
      <Button
        text={literals.viewProgram}
        size='sm'
        onClick={() => navigate(ROUTE_PATH.REFERRALS)}
      />
    </Box>
  );
};

export default ReferralProgramCard;
